import { Button, CircularProgress, IconButton, styled, Typography } from '@mui/material';
import { alpha, Box, Stack } from '@mui/system';
// eslint-disable-next-line import/no-extraneous-dependencies
import { WALLET_ADAPTERS } from '@web3auth/base';
import { LOGIN_PROVIDER_TYPE } from '@web3auth/openlogin-adapter';
import { useWeb3Auth } from 'app/providers/Web3AuthProvider';
import { TwitchLogo, yandexLogo } from 'shared/assets';
import { COLOR_ACCENT, COLOR_BG, COLOR_DARK_AUTH, COLOR_WHITE } from 'shared/config';
import { FontFamilies, FontWeights } from 'shared/config/theme/Typography';
import { Discord, Facebook, Google, Twitter } from 'shared/ui/components';
import { useTranslation } from 'react-i18next';

const SocialLoginButton = styled(Button)({
  background: COLOR_DARK_AUTH,
  borderRadius: '8px',
  height: 46,
  fontFamily: FontFamilies.authModal,
  fontWeight: FontWeights.Bold,
  fontSize: 16,
  lineHeight: '24px',
  color: COLOR_WHITE,
  width: '100%',
  border: 'none',
  '&:hover': {
    background: alpha(COLOR_ACCENT, 0.5),
  },
});

const SocialLoginIconButton = styled(IconButton)(({ theme }) => ({
  borderColor: theme.themeColors.borderMain,
  '&:hover': {
    borderColor: theme.themeColors.borderAccent,
    background: 'transparent',
  },

  '.MuiSvgIcon-root': {
    width: 'unset',
    height: 'unset',
  },
}));

export const Web3AuthConnectForm = () => {
  const { t, i18n } = useTranslation();
  const { login, isLoading } = useWeb3Auth();

  const handleLogin = async (provider: LOGIN_PROVIDER_TYPE) => {
    await login(WALLET_ADAPTERS.AUTH, provider);
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(280.89deg, #9B4DFF -3.98%, #2DF6DE 91.81%)',
        width: '100%',
        borderRadius: '16px',
        maxWidth: '510px',
      }}
    >
      <Stack
        spacing={3}
        sx={{
          backgroundColor: 'rgb(25, 24, 54)',
          borderRadius: '16px',
          margin: '3px',
          padding: '24px',
          paddingBottom: 5.5,
        }}
      >
        <Stack width="100%" direction="row" justifyContent="space-between">
          <Typography
            fontFamily={FontFamilies.secondary}
            fontWeight={FontWeights.Medium}
            fontSize={30}
            lineHeight="30px"
          >
            {t('SingUp')}
          </Typography>
        </Stack>

        {isLoading && (
          <Box
            position="absolute"
            zIndex={9999}
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100%"
            left={0}
            top={0}
            bgcolor={alpha(COLOR_BG, 0.5)}
          >
            <CircularProgress size={50} sx={{ color: COLOR_WHITE }} />
          </Box>
        )}
        <Stack width="100%" spacing={2}>
          <SocialLoginButton onClick={() => handleLogin('google')}>
            <Google sx={{ mr: 1 }} /> {t('ContinueWithGoogle')}
          </SocialLoginButton>
          {/*<Stack direction="row" gap={2} justifyContent="center">
            <SocialLoginIconButton onClick={() => login(WALLET_ADAPTERS.AUTH, 'facebook')}>
              <Facebook />
            </SocialLoginIconButton>
            <SocialLoginIconButton onClick={() => login(WALLET_ADAPTERS.AUTH, 'twitter')}>
              <Twitter />
            </SocialLoginIconButton>
            <SocialLoginIconButton onClick={() => login(WALLET_ADAPTERS.AUTH, 'discord')}>
              <Discord />
            </SocialLoginIconButton>
            <SocialLoginIconButton onClick={() => login(WALLET_ADAPTERS.AUTH, 'twitch')}>
              <img src={TwitchLogo} width={28} height={28} alt="" />
            </SocialLoginIconButton>
            <SocialLoginIconButton onClick={() => login(WALLET_ADAPTERS.AUTH, 'jwt')}>
              <img src={yandexLogo} width={28} height={28} alt="" />
            </SocialLoginIconButton>
          </Stack>*/}
        </Stack>
      </Stack>
    </Box>
  );
};
